<app-input-wrapper
  [ngClass]="{
    'input--error': fc?.errors && fc?.touched
  }"
  [fc]="fc"
  [label]="label"
>
  <textarea
    class="input textarea"
    [rows]="rows"
    [formControl]="fc"
    [placeholder]="placeholder"
    [attr.maxlength]="maxLength"
  ></textarea>
</app-input-wrapper>
